var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDekstop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 22,
    viewBox: "0 0 26 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2942 0H2.11775C0.94817 0 9.91821e-05 0.948102 9.91821e-05 2.11765V15.8824C9.91821e-05 17.0519 0.94817 18 2.11775 18H23.2942C24.4638 18 25.4119 17.0519 25.4119 15.8824V2.11765C25.4119 0.948102 24.4638 0 23.2942 0ZM8.47069 19.0588C7.8859 19.0588 7.41187 19.5329 7.41187 20.1176C7.41187 20.7024 7.8859 21.1765 8.47069 21.1765H16.9413C17.526 21.1765 18.0001 20.7024 18.0001 20.1176C18.0001 19.5329 17.526 19.0588 16.9413 19.0588H8.47069Z",
    fill: "#2F2F2F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.52954,
    y: 1.32227,
    width: 6.61765,
    height: 1.32353,
    rx: 0.661765,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDekstop);
export default __webpack_public_path__ + "static/media/dekstop.0a68a79fed82f4f91a5ec0288121f1b8.svg";
export { ForwardRef as ReactComponent };